$ ->
  ## Change the value of the Edit link below any select dropdown upon selection change
  $('body.site_templates .form-group.select select').change(->
    es = $(this).closest('.form-group.select').find('a.edit-selected')
    if es.length > 0
      es
        .attr('href', es.attr('href')
        .replace(/(.*?)\/[-\d]+\/edit/, "$1/" + $(this).val() + "/edit"))
  ).change()
